class UserPermission {
	id = null;
	members_personal_info = 0;
	members_bookstore = 0;
	departments = 0;
	branches = 0;
	payments = 0;
	subscriptions = 0;
	reports = 0;
	settings = 0;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default UserPermission;
